export function spinner(ctx) {
    return {
        styles: {
            // background arc (main) line = arc_bg
            main:      { bg_color: ctx.SCR, bg_opa: 0, border_width: 0, border_color: 'black', radius: 0, line_color: '#202020', line_width: 15 },
            // indicator arc = arc_indic
            indicator: { line_color: ctx.primary, line_rounded: true },
        },
    };
}
